import { Link } from "react-router-dom";
import { formatPrice } from "../../../../../utils/price.utils";
import { getProductPdpUrl } from "../../../../../utils/url.utils";

const OrderItems = ({ items }) => {

    return (
        <>
            {items?.map((item) => (

                <div className="product-item" key={item.id}>

                    <Link to={getProductPdpUrl(item.action_url, item.sku)} target="_blank">
                        <img src={item.product_media} alt={item.product_name} />
                    </Link>

                    <div className="product-details">

                        <p>
                            <Link to={getProductPdpUrl(item.action_url, item.sku)}>
                                {item.product_name}
                            </Link>
                        </p>

                        <p>Color: {item.color}</p>
                        <p>Size: {item.size}</p>
                        <p>Selling Price: {formatPrice(item.selling_price)}</p>
                        <p>Quantity: {item.quantity}</p>

                    </div>

                </div>

            ))}
        </>
    );
};

export default OrderItems;